import "./style.scss";
import {
  Typography,
  Checkbox,
  IconButton,
  Box,
  FormControlLabel,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import {
  formatMoney,
  Button,
  ReplaceAllInstances,
  enumsCashback,
  enumsSetting,
} from "@itarget/shared";
import { dateFormatTranslation } from "@itarget/shared/src/utils/format/date";
import TypographyValue from "../../components/Layout/Typography/TypographyValue";
import { makeStyles } from "@material-ui/styles";
import ChipCashback from "../CardOffers/ChipCashback";
import { translate } from "../../utils/translation";
import {
  ChipAccumulationCashback,
  ChipRedemptionCashback,
} from "../CardOffers/ChipCashback copy";
import { ExpiredBelt } from "../ExpiredBelt";

const useTranslation = () => ({
  totalLabel: translate("Total neste item"),
  expireAt: translate("Vencimento: %s"),
  exclude: translate("Remover do carrinho"),
  selectLabel: translate("Selecionar para compra"),
});

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    flex: 1,
    display: "flex",
    overflow: "hidden",
    position: "relative",
    height: "fit-content",
    gap: theme.spacing(1.5),
    borderRadius: theme.spacing(2.5),
    padding: theme.spacing(2.5, 3.5, 2.5, 1.5),
    minHeight: theme.typography.pxToRem(140),
    backgroundColor: theme.palette.cardToPayment.backgroundColor,
    border: `1px solid ${theme.palette.cardToPayment.borderColor}`,
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      borderWidth: "0 !important",
      padding: theme.spacing(2.5, 0, 2.5, 0),
    },
  },
  image: {
    aspectRatio: 1,
    borderRadius: theme.spacing(1.5),
    maxWidth: theme.typography.pxToRem(100),
  },
  vertical: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1.5),
  },
  informationContainer: {
    flex: 1,
    display: "flex",
    gap: theme.spacing(1.5),
    [theme.breakpoints.down(theme.breakpoints.values.lg)]: {
      flexDirection: "column",
    },
  },
  detailContainer: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  description: {
    lineHeight: 1.08,
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.cardToPayment.textColor,
  },
  expireAt: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cardToPayment.labelColor,
  },
  priceContainer: {
    display: "flex",
    gap: theme.spacing(0.5),
    flexDirection: "column",
    paddingRight: theme.spacing(2),
  },
  amount: {
    "& span": {
      lineHeight: 1,
      fontWeight: 600,
      color: theme.palette.cardToPayment.textColor,
      fontSize: `${theme.typography.pxToRem(20)} !important`,
    },
  },
  label: {
    lineHeight: 1,
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.cardToPayment.labelColor,
  },
  extraContainer: {
    flex: 1,
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "space-between",
  },
  chipCashback: {
    padding: 0,
  },
  actionsContainer: {
    flex: 1,
    display: "flex",
    flexWrap: "nowrap",
    alignItems: "center",
    gap: theme.spacing(2),
    justifyContent: "flex-end",
    top: theme.typography.pxToRem(11),
    right: theme.typography.pxToRem(31),
    [theme.breakpoints.down(theme.breakpoints.values.md)]: {
      justifyContent: "space-between",
      flexWrap: "wrap",
    },
  },
  closeButton: {
    flex: 0,
    minHeight: 0,
    padding: theme.spacing(0.5, 1.5),
    borderRadius: theme.spacing(1.5),
    "& .MuiButton-label": {
      fontWeight: 400,
      fontSize: theme.typography.pxToRem(12),
    },
    [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
      padding: theme.spacing(1, 1.5),
    },
  },
  checkbox: {
    margin: 0,
    "& .MuiCheckbox-root": {
      marginRight: theme.spacing(0.5),
      width: theme.typography.pxToRem(20),
      height: theme.typography.pxToRem(20),
    },
    "& .MuiTypography-root": {
      lineHeight: 1,
      fontSize: theme.typography.pxToRem(12),
    },
    [theme.breakpoints.down(theme.breakpoints.values.xs)]: {
      padding: theme.spacing(1.5),
      "& .MuiTypography-root": {
        display: "none",
      },
    },
  },
}));

const CardToPayment = ({
  card,
  onChange,
  openModal,
  setting,
  activityChecked,
  courses,
}) => {
  const styles = useStyles();
  const translation = useTranslation();
  const { PRODUCTS_CAMPINGS } = enumsCashback;
  const selectedLang = useSelector((state) => state.language.lang);
  if (!card) return <></>;
  const cashback = card.cashback || [];
  const isExpired = card.esta_vencido === "S";
  const canExpire = card?.exibir_programacao_horario === "S";
  const expireAt = dateFormatTranslation(
    selectedLang,
    card.data_vencimento ? card.data_vencimento : card.data_fim_aga
  );
  const canRemoveFromShoppingCart = !(
    setting?.data
      ?.filter((s) => s.codigo === enumsSetting.ANNUITY_GROUP_PAYMENT_REQUIRED)
      .filter((f) => f.ativo === "S").length > 0 &&
    card.categoria_tipo_atividade === 1
  );
  return (
    <Box key={card.conta_receber_id} className={styles.cardContainer}>
      {isExpired && <ExpiredBelt />}

      <Box display="flex" alignItems="center" height="fit-content">
        {!card.pacote_centro_custo_id && card.thumb && (
          <img
            className={styles.image}
            alt={`thumb do ${card.descricao}`}
            src={card.thumb}
          />
        )}
      </Box>

      <Box className={styles.vertical}>
        <Box className={styles.informationContainer}>
          <Box className={styles.detailContainer}>
            {canExpire && (
              <Typography className={styles.expireAt}>
                {ReplaceAllInstances(translation.expireAt, [expireAt])}
              </Typography>
            )}
            <Typography className={styles.description}>
              {card.descricao}
            </Typography>
          </Box>

          <Box className={styles.priceContainer}>
            <Typography className={styles.label}>
              {translation.totalLabel}
            </Typography>
            <TypographyValue
              className={styles.amount}
              value={formatMoney.toReal(card.valor)}
            />
          </Box>
        </Box>

        <Box className={styles.extraContainer}>
          <Box>
            <ChipAccumulationCashback
              className={styles.chipCashback}
              data={cashback}
            />
            <ChipRedemptionCashback
              className={styles.chipCashback}
              payWithCashback={card.pagar_com_cashback}
              payWithCashbackPercentage={card.percentual_cashback}
            />
          </Box>
          <Box className={styles.actionsContainer}>
            {canRemoveFromShoppingCart && (
              <Button
                color="error"
                className={styles.closeButton}
                onClick={() => openModal(card)}
              >
                {translation.exclude}
              </Button>
            )}
            {!isExpired && (
              <FormControlLabel
                className={styles.checkbox}
                control={
                  <Checkbox
                    onChange={(e) => onChange(e, card)}
                    checked={
                      activityChecked.includes(card.conta_receber_id) &&
                      validatorChecked()
                    }
                  />
                }
                label={translation.selectLabel}
              />
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );

  function validatorChecked() {
    return (
      card.pre_agenda_atividades?.length < 0 ||
      card.pre_agenda_atividades.every((pre_agenda) =>
        activityChecked.includes(
          courses.find(
            (course) =>
              course.agenda_atividade_id === pre_agenda.agenda_atividade_pre_id
          )?.conta_receber_id
        )
      ) ||
      !card.pre_agenda_atividades.every((pre_atividade) =>
        courses.some(
          (course) =>
            course.agenda_atividade_id === pre_atividade.agenda_atividade_pre_id
        )
      )
    );
  }
};
export default CardToPayment;
